module.exports = __webpack_public_path__ + "static/media/0323_Small.a76c37aa.jpg";